import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Button, Modal, Spinner, OverlayTrigger, Tooltip, Alert } from "react-bootstrap";
import { API } from 'aws-amplify';
import { getAuthToken } from '../../../utils/AuthUtils';
import { ToastContext } from '../../../Contexts/ToastProvider';

import './styles.scss';
import GenericGridComponent from '../../../GenericGridComponent/GenericGridComponent';

const ViewCompanyListModal = ({ show, onClose }) => {
    const [companyListData, setCompanyListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const { showToast } = useContext(ToastContext);

    const handleClose = () => {
        setCompanyListData([]);
        setLoading(false);
        setError("");
        onClose();
    }

    const handleCopyTickers = async (companyList, showToast) => {
        const tickerStr = companyList.join(", ");
        await navigator.clipboard.writeText(tickerStr);
        showToast(`Copied ${tickerStr} to clipboard`);
    }

    const handleDeleteTickers = async (recordId, showToast) => {
        const authToken = await getAuthToken();
        setLoading(true);
        setError("");

        API.del('AnnualCompensations', `/custom-company-list/${recordId}`, {
            headers: {
                'Token': authToken
            }
        }).then((response) => {
            showToast("Custom Company List deleted successfully");
            retrieveData();
        }).catch((error) => {
            console.log(error);
            setLoading(false);
            setError("Error deleting custom company list");
        })
    }

    const retrieveData = useCallback(async () => {
        const authToken = await getAuthToken();
        setLoading(true);
        setError("");

        API.get('AnnualCompensations', '/custom-company-list', {
            headers: {
                'Token': authToken
            }
        }).then((response) => {
            setCompanyListData(response);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
            setError("Error retrieving company list data");
        })
    }, [])

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            setLoading(false);
            setError("");
            if (show === true) {
                retrieveData();
            }
        }
    }, [show, retrieveData])

    const actions = (row) => {
        return (
            <div className="action-buttons">
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Copy Tickers</Tooltip>}
                >
                    <span>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            className="copy-btn"
                            onClick={() => handleCopyTickers(row.companyList, showToast)}
                            aria-label="Copy Tickers"
                        >
                            <i className="fa fa-copy" />
                        </Button>
                    </span>
                </OverlayTrigger>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Delete List</Tooltip>}
                >
                    <span>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            className="delete-btn"
                            onClick={() => handleDeleteTickers(row.recordId, showToast)}
                            aria-label="Delete List"
                        >
                            <i className="fa fa-trash" />
                        </Button>
                    </span>
                </OverlayTrigger>
            </div>
        )
    }
    const columns = [
        {
            key: "actions",
            sortable: false,
            filterable: false,
            width: "10%",
            formatter: (props) => {
                return (
                    actions(props.row)
                )
            }
        },
        {
            key: "title",
            name: "Title",
            width: "20%",
            sortable: true,
            filterable: true
        },
        {
            key: "notes",
            name: "Notes",
            width: "25%",
            sortable: true,
            filterable: true
        },
        {
            key: "numCompanies",
            name: "No. Companies",
            width: "10%",
            sortable: true,
            filterable: true
        },
        {
            key: "companyList",
            name: "Tickers",
            width: "35%",
            sortable: true,
            filterable: true,
            formatter: (props) => {
                return (
                    props.row.companyList.join(", ")
                )
            }
        }
    ]

    return (

        <Modal show={show} onHide={handleClose} size='xl' centered dialogClassName="dashboard-modal">
            <div className="view-company-list-container">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Saved Companies Lists
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading && <Spinner animation="border" variant="primary" className="spinner-blue" />}
                    {error && <Alert variant='danger' dismissible>{error}</Alert>}
                    {companyListData?.length > 0 &&
                        <GenericGridComponent
                            columns={columns}
                            data={companyListData}
                            enableGridToCSV={true}
                            useCustomExportMethod={false}
                            fileName={"Saved_Company_Lists"}
                            itemsName={"Saved Company Lists"}
                            selectedCurrentPage={currentPage}
                            onCurrentPageSelect={(page) => setCurrentPage(page)}
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="btn btn-secondary" onClick={handleClose} style={{ "width": "20%" }} >
                        Close
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    )
}

export default ViewCompanyListModal;
